package dev.akshaychordiya.pages.articles

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initExploringRoomArchitectureComponentTheExtrasPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("articles/ExploringRoomArchitectureComponentTheExtras.md", FrontMatterElement.Builder { addScalar("title", "Exploring Room Architecture component — The Extras"); addScalar("date", "2017-12-09"); addScalar("description", "In this article we will be exploring “extras” aka extra features of Room library."); addScalar("originalUrl", "https://proandroiddev.com/exploring-room-architecture-component-the-extras-cf3f0259ceed"); addScalar("originalName", "Medium"); addScalar("image", "/images/articles/exploring-room-architecture-component-the-extras/17aJPlxn8gwhI7JjcBFr-tQ.webp"); }))
}

@Page("/articles/exploring-room-architecture-component-the-extras")
@Layout(".components.layouts.ArticleLayout")
@Composable
fun ExploringRoomArchitectureComponentTheExtrasPage() {
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/exploring-room-architecture-component-the-extras/17aJPlxn8gwhI7JjcBFr-tQ.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("SQL queries (")
            com.varabyte.kobweb.silk.components.navigation.Link("https://unsplash.com/photos/fPkvU7RDmCo") {
                org.jetbrains.compose.web.dom.Text("Credits")
            }
            org.jetbrains.compose.web.dom.Text(")")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("exploring-room-architecture-component-the-extras") }) {
        org.jetbrains.compose.web.dom.Text("Exploring Room Architecture component — The Extras")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("content") }) {
        org.jetbrains.compose.web.dom.Text("Content")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/introduction-to-android-architecture-components-22b8c84f0b9d") {
                org.jetbrains.compose.web.dom.Text("Introduction to Android Architecture Components")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/exploring-viewmodel-architecture-component-5d60828172f9") {
                org.jetbrains.compose.web.dom.Text("Exploring ViewModel Architecture component")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/exploring-livedata-architecture-component-f9375d3644ee") {
                org.jetbrains.compose.web.dom.Text("Exploring LiveData Architecture component")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/exploring-room-architecture-component-6db807094241") {
                org.jetbrains.compose.web.dom.Text("Exploring Room Architecture component")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/exploring-room-the-extras-cf3f0259ceed") {
                org.jetbrains.compose.web.dom.Text("Exploring Room Architecture component — The Extras")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/building-modern-apps-using-the-android-architecture-guidelines-3238fff96f14") {
                org.jetbrains.compose.web.dom.Text("Building Modern apps using the Android Architecture Guidelines")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("preface") }) {
        org.jetbrains.compose.web.dom.Text("Preface")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In this article we will be exploring “")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("extras")
        }
        org.jetbrains.compose.web.dom.Text("” aka extra features of ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/topic/libraries/architecture/room.html") {
            org.jetbrains.compose.web.dom.Text("Room")
        }
        org.jetbrains.compose.web.dom.Text(" library.")
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("In case you are ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("not aware")
            }
            org.jetbrains.compose.web.dom.Text(" about Room then check out my previous article ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/exploring-room-architecture-component-6db807094241") {
                org.jetbrains.compose.web.dom.Text("Exploring Room architecture component")
            }
            org.jetbrains.compose.web.dom.Text(" or if you don’t know about architecture components then head on to ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/introduction-to-android-architecture-components-22b8c84f0b9d") {
                org.jetbrains.compose.web.dom.Text("Introduction to Android Architecture Components")
            }
            org.jetbrains.compose.web.dom.Text(".")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("transaction-support") }) {
        org.jetbrains.compose.web.dom.Text("Transaction support")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Room by default runs queries like insert, update and delete in a transaction. But in order to run other queries like select query or when running multiple queries in a single transaction, the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/Transaction.html") {
            org.jetbrains.compose.web.dom.Text("Transaction")
        }
        org.jetbrains.compose.web.dom.Text(" annotation has been introduced since 1.0.0-rc1.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("It marks the function in the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/Dao.html") {
            org.jetbrains.compose.web.dom.Text("Dao")
        }
        org.jetbrains.compose.web.dom.Text(" class as ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("transaction function")
        }
        org.jetbrains.compose.web.dom.Text(" in order to execute it in a transaction.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("multiple-queries") }) {
        org.jetbrains.compose.web.dom.Text("Multiple queries")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Sometimes we want to perform multiple operations on the database. Let’s say I want to insert a new record and update the record at the same time, by default these both operations will run in their own transaction which might lead to inconsistency (in case if the 1st operation is successful and 2nd one fails).")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In those situations we can create a ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("non-abstract function")
        }
        org.jetbrains.compose.web.dom.Text(" containing both the operations and executing it in a single transaction by marking it with ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/Transaction.html") {
            org.jetbrains.compose.web.dom.Text("Transaction")
        }
        org.jetbrains.compose.web.dom.Text(" annotation.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/d5d4fa9a914f8f098a1a3915ffaf6e01/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Here, the insertAndUpdate function runs in a single transaction and inserts a new user and immediately updates the user’s name to all CAPS.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("for-query") }) {
        org.jetbrains.compose.web.dom.Text("For @Query")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("There are 2 main use-cases to use the transaction annotation with select query:")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("When the result of the query is big, it’s better to run it in transaction for consistent result")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("When the result of the query is a POJO (most likely ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/Embedded.html") {
                org.jetbrains.compose.web.dom.Text("Embedded")
            }
            org.jetbrains.compose.web.dom.Text(") with ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/Relation.html") {
                org.jetbrains.compose.web.dom.Text("Relation")
            }
            org.jetbrains.compose.web.dom.Text(" fields, these fields are queried separately. Hence it’s better to run it in a transaction to receive consistent results between these queries.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Read more about @Transaction and @Query:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/Transaction.html") {
            org.jetbrains.compose.web.dom.Text("Transaction | Android Developers")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("rxjava-support") }) {
        org.jetbrains.compose.web.dom.Text("RxJava support")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Room supports RxJava2 to perform reactive queries out-of-the box which is like yay for Rx fans or people who are already using RxJava in their applications.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("features") }) {
        org.jetbrains.compose.web.dom.Text("Features")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("It supports ")
            com.varabyte.kobweb.silk.components.navigation.Link("http://reactivex.io/RxJava/javadoc/io/reactivex/Maybe.html") {
                org.jetbrains.compose.web.dom.Text("Maybe")
            }
            org.jetbrains.compose.web.dom.Text(", ")
            com.varabyte.kobweb.silk.components.navigation.Link("http://reactivex.io/RxJava/javadoc/io/reactivex/Single.html") {
                org.jetbrains.compose.web.dom.Text("Single")
            }
            org.jetbrains.compose.web.dom.Text(" and ")
            com.varabyte.kobweb.silk.components.navigation.Link("http://reactivex.io/RxJava/javadoc/io/reactivex/Flowable.html") {
                org.jetbrains.compose.web.dom.Text("Flowable")
            }
            org.jetbrains.compose.web.dom.Text(" types to perform observable queries.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The observable / reactive queries are performed on the background thread.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("It’s easier to test, almost similar to testing synchronous queries")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("adding-it-to-the-project") }) {
        org.jetbrains.compose.web.dom.Text("Adding it to the project")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To add RxJava support with Room in your project, you need to add an additional dependency")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code(attrs = { classes("language-kotlin") }) { org.jetbrains.compose.web.dom.Text("// RxJava2 support for Room\nimplementation \"android.arch.persistence.room:rxjava2:1.0.0\"\n") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Read more about RxJava support:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/google-developers/room-rxjava-acb0cd4f3757") {
            org.jetbrains.compose.web.dom.Text("Room 🔗 RxJava")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("indexing") }) {
        org.jetbrains.compose.web.dom.Text("Indexing")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Indexing is the process of adding indexes which are used to ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("quickly locate data")
        }
        org.jetbrains.compose.web.dom.Text(" without having to search every row in a database table every time the database  table is queried or accessed.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Room supports indexing certain fields or indexing group of fields using ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/Entity.html#indices()") {
            org.jetbrains.compose.web.dom.Text("indices")
        }
        org.jetbrains.compose.web.dom.Text(" property to speed up the queries.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("adding-an-index") }) {
        org.jetbrains.compose.web.dom.Text("Adding an index")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To add an index we use the indices property in Entity annotation. It contains the list of the columns to index.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/6f2ee59d67786801882b247c4c37ff16/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("As the indices property takes variable number of parameters, we can have group of indexes or multiple indexes.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/f62d2572b7e0a7139ce81965e7ab4b7b/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("PS: With Kotlin 1.2 we can write array directly using ")
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("[]")
            }
            org.jetbrains.compose.web.dom.Text(" instead of using the ")
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("arrayOf")
            }
            org.jetbrains.compose.web.dom.Text(" function for more conciseness")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The indexes can be marked as unique (by default it is false)using the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/Index.html#unique()") {
            org.jetbrains.compose.web.dom.Text("unique")
        }
        org.jetbrains.compose.web.dom.Text(" property in the Index definition, which enforces uniqueness.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("embedded-index") }) {
        org.jetbrains.compose.web.dom.Text("Embedded index")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We create an ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/Embedded.html") {
            org.jetbrains.compose.web.dom.Text("Embedded")
        }
        org.jetbrains.compose.web.dom.Text(" class when working with ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/Relation.html") {
            org.jetbrains.compose.web.dom.Text("Relation")
        }
        org.jetbrains.compose.web.dom.Text(" in Room. The indexes of embedded entity or entities are ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("not")
        }
        org.jetbrains.compose.web.dom.Text(" carried forward to the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/Embedded.html") {
            org.jetbrains.compose.web.dom.Text("Embedded")
        }
        org.jetbrains.compose.web.dom.Text(" class.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We need to ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("explicitly re-mention")
        }
        org.jetbrains.compose.web.dom.Text(" the required indexes in the Embedded class")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("inheriting-indexes") }) {
        org.jetbrains.compose.web.dom.Text("Inheriting indexes")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Room even supports inheriting indexes from parent class which are carried over to the current Entity using the special property called inheritSuperIndices which takes a boolean value.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("By default, the value of the property is false. On setting it to true all the indexes from parent class are carried to the current Entity.")
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Note that even if the ")
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("Entity")
            }
            org.jetbrains.compose.web.dom.Text(" has a parent which sets this value to ")
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("false")
            }
            org.jetbrains.compose.web.dom.Text(", the ")
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("Entity")
            }
            org.jetbrains.compose.web.dom.Text(" will still inherit indices from it and its parents.")
        }
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Indexing usually speeds up the select queries but slows down the other queries like insert, update and delete. Hence make sure to use indexing where it is really required")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("type-converter") }) {
        org.jetbrains.compose.web.dom.Text("Type Converter")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Room supports basic data types but sometimes these are not sufficient. At such times we require custom data types to be stored in the database. That’s when ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/TypeConverter.html") {
            org.jetbrains.compose.web.dom.Text("TypeConverter")
        }
        org.jetbrains.compose.web.dom.Text(" comes in to rescue!")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/TypeConverter.html") {
            org.jetbrains.compose.web.dom.Text("TypeConverter")
        }
        org.jetbrains.compose.web.dom.Text(" specifies how the conversion happens between Java / Kotlin object to it’s database equivalent which helps Room in deciding how to save the custom data type in the database.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/fb36911822ff259ee9b8f122fcfa6a54/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Here, the DateConverters class is to tell Room how to store and retrieve date from SQLite database. The ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/java/util/Date.html") {
            org.jetbrains.compose.web.dom.Text("Date")
        }
        org.jetbrains.compose.web.dom.Text(" object is stored as Long in the database and while retrieving it is converted back to ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/java/util/Date.html") {
            org.jetbrains.compose.web.dom.Text("Date")
        }
        org.jetbrains.compose.web.dom.Text(" object.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Don’t get confused with ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/TypeConverter.html") {
            org.jetbrains.compose.web.dom.Text("TypeConverter")
        }
        org.jetbrains.compose.web.dom.Text(" and using ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/persistence/room/Relation.html") {
            org.jetbrains.compose.web.dom.Text("Relation")
        }
        org.jetbrains.compose.web.dom.Text(". They serve different purpose.")
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Note: TypeConverter offers only 1 to 1 mapping between Java field / Kotlin property to SQLite column.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("conclusion") }) {
        org.jetbrains.compose.web.dom.Text("Conclusion")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In a nutshell, Room offers a lot of features which is why I needed to write one more article on it.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("With this article, we mark the ending of deep dive of Architecture Components series. In the next parts we will explore how to use Architecture Guidelines and Components to build robust, testable and maintainable apps.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://proandroiddev.com/exploring-room-architecture-component-the-extras-cf3f0259ceed") {
            org.jetbrains.compose.web.dom.Text("Exploring Room Architecture component — The Extras")
        }
        org.jetbrains.compose.web.dom.Text(" was originally published in ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://proandroiddev.com") {
            org.jetbrains.compose.web.dom.Text("ProAndroidDev")
        }
        org.jetbrains.compose.web.dom.Text(" on Medium, where people are continuing the conversation by highlighting and responding to this story.")
    }
}
